import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../auth/auth-guard.service';
import {ProfileListComponent} from './profile-list/profile-list.component';
import {ProfileAddComponent} from './profile-add/profile-add.component';
import {ProfileLimitGuard} from './profile-limit-guard.service';
import {PostListComponent} from './post/post-list/post-list.component';
import {PostAddComponent} from './post/post-add/post-add.component';
import {PostLimitGuard} from './post-limit-guard.service';
import {PostAuditComponent} from './post/post-audit/post-audit.component';
import {ProfileWaitingComponent} from './profile-waiting/profile-waiting.component';
import {ProfilePageComponent} from './profile-page/profile-page.component';
import {CertificateComponent} from './certificate/certificate.component';
import {CertificateWaitingComponent} from './certificate/certificate-waiting/certificate-waiting.component';
import {ProfileTrialCheckComponent} from './trial/profile-trial-check/profile-trial-check.component';
import {ProfileAuditComponent} from './tiktok/profile-audit/profile-audit.component';
import {ProfilePageProComponent} from './profile-page-pro/profile-page-pro.component';

const profileRoutes: Routes = [
  {
    path: 'audits', component: ProfileListComponent, canActivate: [AuthGuard]
  },
  {
    path: 'audit/add', component: ProfileAddComponent, canActivate: [AuthGuard]
  },
  {
    path: 'audit/certificate/:id', component: CertificateWaitingComponent, canActivate: [AuthGuard]
  },
  {
    path: 'audit/certificate/:id/:code', component: CertificateComponent, canActivate: []
  },
  {
    path: 'c/:code', component: CertificateComponent, canActivate: [],
  },
  {
    path: 'audit/trial/:profile/check', component: ProfileTrialCheckComponent, canActivate: []
  },
  {
    path: 'audit/:id', component: ProfilePageComponent, canActivate: [AuthGuard]
  },
  {
    path: 'audit/:id/pro', component: ProfilePageProComponent, canActivate: [AuthGuard]
  },
  {
    path: 'audit/:id/waiting', component: ProfileWaitingComponent, canActivate: [AuthGuard]
  },
  {
    path: 'audit/:id/waiting/:code', component: ProfileWaitingComponent, canActivate: []
  },
  {
    path: 'audit/:id/code/:code', component: ProfilePageComponent, canActivate: []
  },
  {
    path: 'audit/:id/tiktok', component: ProfileAuditComponent, canActivate: [AuthGuard]
  },
  {
    path: 'posts', component: PostListComponent, canActivate: [AuthGuard]
  },
  {
    path: 'post/add', component: PostAddComponent, canActivate: [AuthGuard, PostLimitGuard]
  },
  {
    path: 'post/:id', component: PostAuditComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(profileRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ProfileRoutingModule {}
